import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { stockPartRequestBulkSelector } from '../../store/selectors/stockBulkSelector';
import { submitStockBulk } from '../../store/thunks/stock/stock-part-requests/stockBulkOperationsThunks';
import { ResponseSingleResult } from '../../core/types/coreTypes';
import { PartRequestSubmitBulkResponse } from './types';
import { getStockBulkOperationRedirectUrl } from './utils';
import { BulkRequestTypeEnum } from './BulkRequestTypeEnum';

interface HookReturn {
  processBulk: () => void;
  canProcessBulk: boolean;
}

export const useBulkAction = (operation: BulkRequestTypeEnum | null): HookReturn => {
  const { selectedCount } = useAppSelector(stockPartRequestBulkSelector);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleProcessBulk = useCallback(async () => {
    if (!operation) {
      return;
    }

    const response = await dispatch(submitStockBulk({ operation }));
    const payload = (response.payload as ResponseSingleResult<PartRequestSubmitBulkResponse>);
    if (payload.success) {
      const redirectUrl = getStockBulkOperationRedirectUrl(operation, payload.data);
      navigate(redirectUrl);
    }
  }, [dispatch, navigate, operation]);

  return {
    processBulk: handleProcessBulk,
    canProcessBulk: selectedCount > 0 && !!operation,
  };
};
